/**
 * 兜底策略（设计文档 3.5 / 风险表：规则无决策时降级为最近轿厢响应）。
 *
 * 不区分忙闲，按楼层距离取最近可用轿厢；通过 greedyAssign 做批次内载客感知，
 * 保证任何呼叫都能得到分配且单梯不过载，避免规则引擎（M1）漏判导致停摆。
 */
import type { DispatchStrategy, SnapshotView } from './strategy-api';
import { greedyAssign } from './greedy-assign';

export function createFallbackStrategy(id = 'fallback'): DispatchStrategy {
  return {
    id,
    allocate(view: SnapshotView) {
      return greedyAssign(view.cars, view.calls, (car, call) => Math.abs(car.floor - call.floor));
    },
  };
}
